export const subadminsKey = "subadmins";
export const subadminRolesKey = "subadminRoles";
export const informationPolicyKey = "informationPolicy";
export const categoriesKey = "categories";
export const brandsKey = "brands";
export const pagesKey = "Pages";
export const bannerKey = "banners";
export const bookingsKey = "bookings";
export const paymentsKey = "payments";
export const widgetsKey = "widgets";
export const adminSettingsKey = "adminSettings";
export const clientsKey = "clients";
export const seoKey = "seo";
export const configSettingsKey = "configSettings";
export const templateKey = "template";
export const couponsKey = 'coupons';
export const visitorType = 'visitorType'
export const locationKey = 'location'
export const cancellationRequest = 'cancellation'
export const listingKey = 'listings'

